import React from "react";

const TopNote = ({
  text,
  color = "#f2f2f2", // background default
  borderColor = "transparent", // default no visible border
  borderWidth = "1px",
  fontWeight = 600,
  fontSize, // undefined keeps the browser/inherited default
  textColor = "#000",
  borderRadius = "6px",
  padding = "8px 16px",
}) => {
  return (
    <div
      style={{
        backgroundColor: color,
        border: `${borderWidth} solid ${borderColor}`,
        padding,
        textAlign: "center",
        fontWeight,
        fontSize,
        wordBreak: "break-word",
        whiteSpace: "normal",
        borderRadius,
        marginBottom: "4px",
        color: textColor,
      }}
    >
      {text}
    </div>
  );
};

export default TopNote;
